<div>
    <span class="air-heading">	
TLR Admin Dashboard
</span>
    </div>
<div class="report-container">
    <div class="column">
        <div class="section">
            <div class="section-header">User Interface Configuration
            </div>
            <div class="link-list">
                <a routerLink="/manage-divisions">Manage Divisions:</a>
                <router-outlet></router-outlet>
                <div class="description">Add a new Division to the TLR system. Retire or Unretire an existing Division
                    from the system.</div>
                <a routerLink="/manage-sections">Manage Sections:</a>
                <div class="description">Add a new Section to the TLR system. Retire or Unretire an existing Section
                    from the system.</div>
                <a routerLink="/manage-plants">Manage Plants:</a>
                <div class="description">Add a new Plant to the TLR system. Retire or Unretire an existing Plant from
                    the system.</div>
                <a routerLink="/manage-leaks">Manage Leaks:</a>
                <div class="description">Add a new Leak Type to the TLR system. Retire or Unretire an existing Leak Type
                    from the system.
                </div>
                <a routerLink="/manage-repairTypes">Manage Repair Types:
                </a>
                <div class="description">Add a new Repair Type to the TLR system. Retire or Unretire an existing Repair
                    Type from the system.
                </div>
                <a routerLink="/manage-services">Manage Service:
                </a>
                <div class="description">Add a new Service to the TLR system. Retire or Unretire an existing Service
                    from the system.
                </div>
                <a routerLink="/manage-materialState">Manage Material State:
                </a>
                <div class="description">Add a new Material State to the TLR system. Retire or Unretire an existing
                    Material State from the system.
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                Notification Configurations
            </div>
            <div class="link-list">
                <a routerLink="/app-user-role-management">User and Role Management:</a>
                <div class="description">Ability to Review Users and Roles, Add or Remove a Role from a User.
                </div>
                <a routerLink="/app-email-distribution">Email Distribution:
                </a>
                <div class="description">Ability to Review Email Events, Add or Remove Email Roles from Email Events,
                    and Add and Remove CAIs from Email Roles.
                </div>
                <a routerLink="/oa-maintainance">OA Maintenance:</a>
                <div class="description">Ability to Add, Change, Delete OA CAI's per Plant.
                </div>
                <a routerLink="/omc-maintainance">OMC Maintenance:
                </a>
                <div class="description">Ability to Add, Change, Delete OMC CAI's per Plant.
                </div>
                <a routerLink="/inspector-maintainance">Inspector Maintenance:
                </a>
                <div class="description">Ability to Add, Change, Delete Inspector CAI's per Plant.
                </div>
                <a routerLink="/app-system-message-board">System Message Board:
                </a>
                <div class="description">Ability to Update System Message Board.
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                Daily Update - Manual Execution
            </div>
            <div class="link-list">
                <a routerLink="/app-daily-update-run-command">Daily Update - Run Command:</a>
                <div class="description">Allows the Administrator to manually run the nightly update to synchronize data
                    between the TLR system and external applications.
                </div>
                <a routerLink="/app-daily-update-report">Daily Update - Report:</a>
                <div class="description">This report allows an Administrator to review the errors that were found as a
                    result of the most recent "Daily Update - Run Command".</div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                TLR – Maximo – OERI Hierarchy
            </div>
            <div class="link-list">
                <a routerLink="/app-display-hierarchy">Display Hierarchy:</a>
                <div class="description">The feautures displays the TLR – Maximo – OERI Hierarchy Crosswalk table.
                </div>
                <a routerLink="/app-hirerchy-checker-run-command">Hierarchy Checker - Run Command:</a>
                <div class="description">Allows the Administrator to manually run the TLR Hierarchy Checker looking for
                    hierarchy inconsistancies which are auto emailed to the TLR Super Administrator.
                </div>
            </div>
        </div>
    </div>
    <div class="column">
        <div class="section">
            <div class="section-header">Other Functions
            </div>
            <div class="link-list">
                <a routerLink="/app-tlr-data-editor">TLR Data Editor:</a>
                <div class="description">The ability to edit any existing TLR data that has been submitted by
                    Operations, Air, Inspections, OA or Engineering can be edited by the Administrator.
                </div>
                <a routerLink="/app-tlr-data-editor-permanent-repair-date">TLR Permanent Repair Date Editor:
                </a>
                <div class="description">The ability to edit any existing TLR data Permanent Repair Date. Any data that
                    has been submitted into the Inspections data entry consoles can be edited by the Administrator.
                </div>
                <a routerLink="/app-tlr-editor-change-repaired">TLR Editor Change Repaired TLR to Installed:
                </a>
                <div class="description">The ability to edit a Repaired TLR and make it Installed.</div>
                <a routerLink="/app-tlr-health">TLR Health:</a>
                <div class="description">This report allows an Administrator to review the health of the TLR
                    application.
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                Reports
            </div>
            <div class="link-list">
                <a routerLink="/app-california-regulation-report">California Regulation SB-1300 T/A Law:</a>
                <div class="description">Provides an SB-1300 T/A Law Report.</div>
                <a routerLink="/app-admin-tlr-administartor-ipeg">TLR Administrator IPEG Report</a>
                <div class="description">Provides a list of all TLR Administrators for this Refinery to be used for IPEG
                    tasks.
                </div>
                <a routerLink="/app-admin-reports-anamoly">Anomaly Report:</a>
                <div class="description">Provides a list of Errors the TLR Administrator will address.
                </div>
            </div>
        </div>

        <div class="section">
            <div class="section-header">
                User Guides
            </div>
            <div class="link-list">
                <a (click)="openPdfInNewTab('TLR_Admin_UIConfiguration.pdf')" style="cursor: pointer;">User Interface Configuration:</a>
                <div class="description">Step-by-step guide on how to manipulate the user interface using the Admin’s
                    User Interface Configuration Management Tools.
                </div>                <a (click)="openPdfInNewTab('Admin_ TLR Data Editor.pdf')" style="cursor: pointer;">TLR Data Editor:
                </a>
                <div class="description">Step-by-step guide on how to use the Admin’s TLR Data Editor Tool.
                </div>                <a (click)="openPdfInNewTab('TLR_Admin_UserRoleManagement.pdf')" style="cursor: pointer;">User and Role Management:
                </a>
                <div class="description">Step-by-step guide on how to use the Admin’s User and Role Management Tool.
                </div>                <a (click)="openPdfInNewTab('Admin_ Email Distribution.pdf')" style="cursor: pointer;">Email Distribution:
                </a>
                <div class="description">Step-by-step guide on how to use the Admin’s Email Distribution Tool.
                </div>                <a (click)="openPdfInNewTab('Admin_ Daily Update.pdf')" style="cursor: pointer;">Daily Update:
                </a>
                <div class="description">Step-by-step guide on how to use the Admin’s Daily Update Run Command and
                    Report.
                </div>
            </div>
        </div>

    </div>
</div>
